/**
 * Fallback Logto application IDs that can request a new magic-link email
 * after an expired or consumed one-time token. Prefer
 * `customRegistration.magicLinkRenewClientIds` from the well-known SIE when set.
 */
export const oneTimeTokenRefreshClientIds: readonly string[] = ['placeholder-client-id'];

export const oneTimeTokenClientIdQueryKeys = ['app_id', 'client_id'] as const;

/** Keeps the classic set/reset-password flow even when the new-OTT flag is on. */
export const newOttSourceQueryKey = 'source';

/** `source` values that share the classic set/reset-password flow. */
export const classicOttSources: readonly string[] = [
  'password_reset_link',
  'user_provisioning',
  'password_reset_email',
];
